import event1 from "../assets/events/event1.jpg";
import event2 from "../assets/events/event2.jpeg";
import event3 from "../assets/events/event3.jpg";
import event4 from "../assets/events/event4.jpg";
import event5 from "../assets/events/event5.jpg";
import event6 from "../assets/events/event6.jpg";

export const eventsData = [
    {
        date: "24-07-2022",
        objectif: "Exposer le desaccord sur la hausse de carburant",
        modalites: "Une marche pacifique en partant de l'entree du president jusqu'a la frontiere",
        lieu: "Terminus",
        etat: "next",
        image: event2,
        likes: 30,
        adore: 18,
        cheer: 22
    },
    {
        date: "24-07-2022",
        objectif: "Exposer le desaccord sur la hausse de carburant",
        modalites: "Une marche pacifique en partant de l'entree du president jusqu'a la frontiere",
        lieu: "Terminus",
        etat: "next",
        image: event1,
        likes: 22,
        adore: 12,
        cheer: 18
    },

    {
        date: "24-07-2022",
        objectif: "Exposer le desaccord sur la hausse de carburant",
        modalites: "Une marche pacifique en partant de l'entree du president jusqu'a la frontiere",
        lieu: "Terminus",
        etat: "next",
        image: event2,
        likes: 64,
        adore: 48,
        cheer: 24
    },
    {
        date: "24-07-2022",
        objectif: "Exposer le desaccord sur la hausse de carburant",
        modalites: "Une marche pacifique en partant de l'entree du president jusqu'a la frontiere",
        lieu: "Terminus",
        etat: "next",
        image: event2,
        likes: 43,
        adore: 12,
        cheer: 33
    },

    {
        date: "24-08-2022",
        objectif: "Exposer le desaccord sur la hausse de carburant",
        modalites: "Une marche pacifique en partant de l'entree du president jusqu'a la frontiere",
        lieu: "Terminus",
        etat: "recent",
        image: event3,
        likes: 57,
        adore: 7,
        cheer: 20
    },
    {
        date: "24-07-2022",
        objectif: "Exposer le desaccord sur la hausse de carburant",
        modalites: "Une marche pacifique en partant de l'entree du president jusqu'a la frontiere",
        lieu: "Terminus",
        etat: "next",
        image: event4,
        likes: 75,
        adore: 26,
        cheer: 9
    },

    {
        date: "24-08-2022",
        objectif: "Exposer le desaccord sur la hausse de carburant",
        modalites: "Une marche pacifique en partant de l'entree du president jusqu'a la frontiere",
        lieu: "Terminus",
        etat: "recent",
        image: event5,
        likes: 31,
        adore: 16,
        cheer: 10
    },
    {
        date: "24-07-2022",
        objectif: "Exposer le desaccord sur la hausse de carburant",
        modalites: "Une marche pacifique en partant de l'entree du president jusqu'a la frontiere",
        lieu: "Terminus",
        etat: "next",
        image: event1,
        likes: 34,
        adore: 23,
        cheer: 25
    },
    {
        date: "24-07-2022",
        objectif: "Exposer le desaccord sur la hausse de carburant",
        modalites: "Une marche pacifique en partant de l'entree du president jusqu'a la frontiere",
        lieu: "Terminus",
        etat: "next",
        image: event4,
        likes: 89,
        adore: 23,
        cheer: 40
    },
    {
        date: "24-08-2022",
        objectif: "Exposer le desaccord sur la hausse de carburant",
        modalites: "Une marche pacifique en partant de l'entree du president jusqu'a la frontiere",
        lieu: "Terminus",
        etat: "recent",
        image: event6,
        likes: 12,
        adore: 6,
        cheer: 1
    },

    {
        date: "24-07-2022",
        objectif: "Exposer le desaccord sur la hausse de carburant",
        modalites: "Une marche pacifique en partant de l'entree du president jusqu'a la frontiere",
        lieu: "Terminus",
        etat: "next",
        image: event1,
        likes: 23,
        adore: 18,
        cheer: 2
    },

    {
        date: "24-08-2022",
        objectif: "Exposer le desaccord sur la hausse de carburant",
        modalites: "Une marche pacifique en partant de l'entree du president jusqu'a la frontiere",
        lieu: "Terminus",
        etat: "recent",
        image: event6,
        likes: 12,
        adore: 3,
        cheer: 4
    },
]
